import React from 'react';
import { Img } from 'component/FrameL';
import ReactMarkdown from 'react-markdown';

import './style.css';

export default ({ cmsData, className }) => {
    let { Photo, Heading, Description } = cmsData;
    Photo = Photo || {};

    return <div className={`np-banner__container ${className}`}>
        <Img Image={Photo} className="object-contain" />
        <stack-l class="justify-center" role="contentinfo" aria-label={Heading}>
            <h3 className="">{Heading}</h3>
            <ReactMarkdown className="text-justify">{Description}</ReactMarkdown>
        </stack-l>
    </div>;
};
